import { defineNuxtPlugin, reloadNuxtApp } from '#app';

export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.hook('app:chunkError', () => {
		reloadNuxtApp({ persistState: true });
	});
});
